import React from "react";
import { useAudio } from "./AudioContext";

export default function GlowShade({
  color,
  top,
  left,
  height,
  width,
  top2 = "auto",
  left2 = "auto",
}) {
  const { isMobile } = useAudio();

  return (
    <div
      className="glowshade"
      style={{
        top: isMobile ? top2 : top,
        left: isMobile ? left2 : left,
        height: height,
        width: width,
        background: color,
      }}
    ></div>
  );
}
